import apolloClient from 'services/apollo-client';
import { get } from 'lodash';
import { SubSurfaceNode } from 'graphql/types';

export default function useCurrentSurface(): SubSurfaceNode {
  // This is a hack because useParams from react router does not work inside konva components
  const surface = window.location.pathname.replace('/surface/', '');

  return get(
    apolloClient.cache,
    'data.data.SubSurfaceNode:' + surface,
    undefined,
  );
}
